module.exports = __webpack_public_path__ + "static/media/Logo2.d1a5ba33.png";